<template>
  <div class="ly_modal_container" :style="{zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">소식톡톡 반복/맞춤 등록</h1>
    </div>
    <div class="ly_modal_content" style="min-height: 472px; min-width: 837px">
      <div v-if="newsData" class="table_wrapper">
        <table class="table_view" style="width: 800px">
          <caption>
            <span class="blind">소식톡톡 반복/맞춤 등록</span>
          </caption>
          <colgroup>
            <col width="120" />
            <col />
          </colgroup>
          <tbody class="table_view_body">
            <RepeatTypeSelector
              :newsType.sync="newsData.newsType"
              :customNewsType.sync="newsData.customNewsType"
              :required="true"
              ref="repeatTypeSelector"
            />
            <TargetSector
              :rcpGroupSendYn.sync="newsData.rcpGroupSendYn"
              :selectedRcpList.sync="selectedRcpList"
              :required="true"
              ref="targetSelector"
            />
            <ContentInput
              :boardContent.sync="newsData.boardContent"
              :required="true"
              :useSample="true"
              :maxLength="300"
              ref="contentInput"
            />
            <RepeatStrategySelector
              :period.sync="newsData.repeatStrategy.period"
              :dayOfWeek.sync="newsData.repeatStrategy.dayOfWeek"
              ref="repeatStrategySelector"
            />
            <RepeatReserveTimeSelector :reserveTime.sync="newsData.reserveTime" ref="repeatReserveTimeSelector" />
            <SnoozeSelector
              v-if="newsData.newsType === 'REPEAT'"
              :hasSnooze.sync="newsData.hasSnooze"
              :snoozeMax.sync="newsData.snoozeMax"
              :snoozeInterval.sync="newsData.snoozeInterval"
              :intervalList="[0, 1, 2, 3, 4, 5, 6, 7]"
              ref="snoozeSelector"
            />
            <RepeatExperationDateSelector :from.sync="newsData.validFrom" :to.sync="newsData.validTo" ref="repeatExperationDateSelector" />
          </tbody>
        </table>

        <div class="btn_area">
          <button type="button" class="btn_active" @click="submit">등록</button>
          <button type="button" class="btn_default" @click="close">닫기</button>
        </div>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from '$mixins/popup';
import newsMixin from '$views/News/_mixin';
import newsRegisterMixin, {defaultData} from './mixins/register';

import RepeatTypeSelector from './inputs/RepeatTypeSelector';
import TargetSector from './inputs/TargetSelector';
import TitleInput from './inputs/TitleInput';
import ContentInput from './inputs/ContentInput';
import SnoozeSelector from './inputs/SnoozeSelector';

import RepeatStrategySelector from './inputs/RepeatStrategySelector';
import RepeatReserveTimeSelector from './inputs/RepeatReserveTimeSelector';
import RepeatExperationDateSelector from './inputs/RepeatExperationDateSelector';

export default {
  mixins: [popupMixin, newsMixin, newsRegisterMixin],
  props: {
    onSubmit: Function,
  },
  components: {
    RepeatTypeSelector,
    TargetSector,
    TitleInput,
    ContentInput,
    SnoozeSelector,
    RepeatStrategySelector,
    RepeatReserveTimeSelector,
    RepeatExperationDateSelector,
  },
  data() {
    return {
      newsData: _.merge({}, defaultData, {newsType: 'REPEAT'}),
      selectedRcpList: [],
    };
  },
  computed: {
    apiUrl() {
      return this.newsData.newsType === 'REPEAT' ? '/admin/v2/news/repeat' : '/admin/v2/news/custom';
    },
  },
  watch: {
    'newsData.newsType'(val) {
      if (val === 'CUSTOM') {
        this.newsData.hasSnooze = false;
        this.newsData.snoozeMax = 0;
        this.newsData.snoozeInterval = 0;
      }
    },
  },
  methods: {
    submit() {
      if (!this.validate()) return false;
      const params = {
        newsType: this.newsData.newsType,
        customNewsType: this.newsData.customNewsType,
        boardTitle: this.newsData.boardTitle,
        boardContent: this.newsData.boardContent,
        rcpGroupSendYn: this.newsData.rcpGroupSendYn,
      };
      if (params.rcpGroupSendYn === 'N') {
        params.rcpIdList = _.map(this.selectedRcpList, (item) => item.recipientId);
      } else {
        const groupData = this.$refs.targetSelector.getGroupData();
        params.orgCode = groupData.orgId;
        params.rcpState = groupData.stateId;
        params.addrCity = groupData.cityId;
        params.rcpGroup = groupData.groupId;
      }

      const {repeatStrategy, reserveTime, snoozeMax, snoozeInterval, validFrom, validTo, hasSnooze} = this.newsData;
      Object.assign(params, {
        repeatStrategy,
        reserveTime,
        snoozeMax,
        snoozeInterval,
        validFrom,
        validTo,
        hasSnooze,
      });

      const messages = this.newsData.newsType === 'CUSTOM' ? this.getSubmitMessagesCustom() : this.getSubmitMessagesRepeat();
      confirm(messages.confirm).then(() => {
        this.$axios.post(this.apiUrl, params).then(() => this.onSubmitData(messages.complete));
      });
    },
    onSubmitData(msg) {
      alert(msg);
      if (this.onSubmit) this.onSubmit();
      this.close();
    },
    validate() {
      const isHealth = this.newsData.customNewsType === 'WELLNESS_UNUSED_7DAYS';
      if (
        !this.$refs.repeatTypeSelector.validate() ||
        isHealth ||
        !this.$refs.targetSelector.validate() ||
        !this.$refs.contentInput.validate() ||
        !this.$refs.repeatStrategySelector.validate() ||
        (this.$refs.snoozeSelector && !this.$refs.snoozeSelector.validate())
        // !this.$refs.sendTimeSelector.validate()
      ) {
        if (isHealth) alert('건강톡톡은 현재 등록 할 수 없습니다.');
        return false;
      }

      return true;
    },
  },
};
</script>
